import { PropsWithChildren } from 'react';
import NavigationCarousel from '@/features/carousel/navigation-carousel';
import { cn } from '@/utils/cn';
interface Props extends PropsWithChildren {
  isCarousel: boolean;
  spacing: number;
  className?: string;
}
const VariantsLayoutWrapper = ({
  children,
  isCarousel,
  className,
  spacing
}: Props) => {
  if (isCarousel) {
    return <NavigationCarousel className={cn('!w-full', className)} options={{
      perView: 'auto',
      spacing,
      mode: 'free'
    }} staticChildren>
                {children}
            </NavigationCarousel>;
  }
  return <div className={cn('flex flex-row flex-wrap gap-[3px] lg:gap-2', className)} data-sentry-component="VariantsLayoutWrapper" data-sentry-source-file="variants-layout-wrapper.tsx">{children}</div>;
};
export default VariantsLayoutWrapper;